<template>
  <div>
    <div class="row pt-3">
      <div class="col-md-12">
        <div class="filter-container">
          <ValidationObserver
            ref="formValidator"
            v-slot="{}"
            tag="form"
            class="row pl-3 pr-1"
          >
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-3 py-1">
                  <div class="custom-ddf">
                    <custom-drop-down
                      v-model="Filter.AcademicYear"
                      :options="AcademicYears"
                      placeholder="Seleccione el año"
                      required
                      :fieldkey="'id'"
                      :fieldname="'description'"
                      :clearable="false"
                    />
                  </div>
                </div>
                <div class="col-md-7 py-1">
                  <custom-input
                    v-model="Filter.Sie"
                    placeholder="Escriba Número de SIE"
                    left-icon
                    icon="fa fa-search orange-icon"
                  />
                </div>
                <div class="col-md-2 py-1 pl-0">
                  <action-button
                    text="Buscar"
                    variant="success"
                    class="fr px-4 "
                    @click="getNonMileageServices"
                  />
                  <action-button
                    i="fal fa-sliders-v"
                    variant="orange"
                    class="fr mr-2 pl-3"
                    :class="{ transparent: !advance }"
                    @click="() => (advance = !advance)"
                  />
                </div>
              </div>
            </div>

            <div v-if="advance" class="col-md-12">
              <div class="row py-3">
                <div class="col-md-12">
                  <span class="separator">FILTROS</span>
                </div>
              </div>

              <div class="row">
                <div class="col-4 pt-0 mb-3">
                  <div class="custom-ddf">
                    <vselect
                      ref="SelectService"
                      v-model="Filter.Service"
                      class="bg-white"
                      :options="Services"
                      :reduce="(Service) => Service.id"
                      label="name"
                      placeholder="Seleccione el Servicio"
                    />
                  </div>
                </div>
                <div class="col-4 pt-0">
                  <div class="custom-ddf">
                    <vselect
                      ref="SelectRegion"
                      v-model="Filter.Region"
                      class="bg-white"
                      :options="Regions"
                      :reduce="(Region) => Region.id"
                      label="name"
                      placeholder="Seleccione la Región"
                      @input="ClearField('Region')"
                    />
                  </div>
                </div>
                <div class="col-4 pt-0">
                  <div class="custom-ddf">
                    <vselect
                      ref="SelectDistrict"
                      v-model="Filter.District"
                      class="bg-white"
                      :options="Districts"
                      :reduce="(District) => District.id"
                      label="name"
                      placeholder="Seleccione el Distrito"
                      @input="ClearField('District')"
                    />
                  </div>
                </div>
                <div class="col-4">
                  <div class="custom-ddf">
                    <vselect
                      ref="SelectSchool"
                      v-model="Filter.School"
                      class="bg-white"
                      :options="Schools"
                      :reduce="(School) => School.id"
                      label="name"
                      placeholder="Seleccione la Escuela"
                      @input="ClearField('School')"
                    />
                  </div>
                </div>
                <div class="col-4">
                  <div class="custom-ddf">
                    <vselect
                      ref="SelectCenter"
                      v-model="Filter.Center"
                      class="bg-white"
                      :options="Centers"
                      :reduce="(Center) => Center.id"
                      label="name"
                      placeholder="Seleccione el Centro"
                    />
                  </div>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-12">
        <custom-separator text="Servicios sin Millaje" />
      </div>
    </div>

    <div class="row pt-2">
      <div class="col-12">
        <row
          v-for="(item, index) in items"
          :key="`row-item-${index}`"
          :item="item"
          :on-save="updateMileage"
          :resources="resources"
          @onEdit="onEdit"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-12 pt-0">
        <customPager
          :per-page="pagi.count"
          :total="pagi.totalItemCount"
          :page-changed="pageChanged"
          :per-page-changed="perPageChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CustomInput from '@/components/common/CustomInput';
import ActionButton from '@/components/common/ActionButton';
import CustomSeparator from '@/components/common/CustomSeparator';
import { ValidationObserver } from 'vee-validate';
import CustomDropDown from '@/components/common/CustomDropDown';
import vselect from 'vue-select';
import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';
import Row from '../components/Row';
import resourcesService from '@/services/resources.js';

export default {
  name: 'NonMileageServices',
  mixins: [mixAlert, mixWait],
  components: {
    CustomInput,
    ActionButton,
    CustomSeparator,
    vselect,
    CustomDropDown,
    ValidationObserver,
    // ValidationProvider,
    Row,
  },
  data() {
    return {
      advance: false,
      Filter: {
        AcademicYear: null,
        Region: null,
        District: null,
        School: null,
        Center: null,
        Sie: null,
        Service: null,
      },
      currentAcademicYear: null,
      AcademicYears: [],
      Regions: [],
      Districts: [],
      Schools: [],
      Centers: [],
      Services: [],
      resources: [],
      validationMessages: [],
      errorMessage:
        'Favor de completar la información solicitada para iniciar búsqueda.',
      items: [],
      pagi: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 20,
      },
    };
  },
  methods: {
    onEdit(itemId) {
      this.items
        .filter((x) => x.id !== itemId)
        .map((c) => {
          c.editMode = false;
          c.mileage = null;
          c.commentary = null;
          c.companion = null;
          return c;
        });
    },
    async loadResources() {
      let resourceCodes = ['18018', '21080', '21081', '21076'];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    ClearField(ddlType) {
      let self = this;

      switch (ddlType) {
        case 'AcademicYear':
          self.$refs.SelectRegion.maybeDeleteValue();
          self.$refs.SelectDistrict.maybeDeleteValue();
          self.$refs.SelectSchool.maybeDeleteValue();
          self.$refs.SelectCenter.maybeDeleteValue();
          break;
        case 'Region':
          self.$refs.SelectDistrict.maybeDeleteValue();
          self.$refs.SelectSchool.maybeDeleteValue();
          self.loadDistricts();
          break;
        case 'District':
          self.$refs.SelectSchool.maybeDeleteValue();
          self.loadSchools();
          break;
      }
    },
    async getCurrentAcademicYear() {
      await this.$ApiGet('/api/academicyears/current').then((res) => {
        this.currentAcademicYear = res.data;
      });
    },
    LoadAcademicYears() {
      let self = this;
      self
        .$ApiGet(`api/academicyears/getacademicyearstocurrentyear`)
        .then((response) => {
          //Año actual por defecto
          if (response.data.length > 0) {
            self.AcademicYears = response.data;
            this.Filter.AcademicYear = {
              id: self.currentAcademicYear.id,
              description: self.currentAcademicYear.description,
            };
            self.loadRegions();
            self.loadCenters();
          }
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    loadRegions() {
      let self = this;
      self
        .$ApiGet(
          `api/schools/types/regions?academicyear=${self.Filter.AcademicYear.id}`
        )
        .then((response) => {
          self.Regions = response.data;
        });
    },
    loadDistricts() {
      let self = this;
      self
        .$ApiGet(
          `api/schools/types/regions/districts?regionid=${self.Filter.Region}&academicyear=${self.Filter.AcademicYear.id}`
        )
        .then((response) => {
          self.Districts = response.data;
        });
    },
    loadSchools() {
      let self = this;
      self
        .$ApiGet(
          `api/schools?districtid=${self.Filter.District}&academicyear=${self.Filter.AcademicYear.id}`
        )
        .then((response) => {
          self.Schools = response.data;
        });
    },
    loadCenters() {
      let self = this;
      self
        .$ApiGet(
          `api/schools/academicYear/centers?academicyear=${self.Filter.AcademicYear.id}`
        )
        .then((response) => {
          self.Centers = response.data;
        });
    },
    loadServices() {
      let self = this;
      self
        .$ApiGet(
          `api/code/getcodedisciplinetypes?serviceTypeId=3&ValidForFlag=Pei`
        )
        .then((response) => {
          self.Services = response.data;
        });
    },
    async LoadAlls() {
      let self = this;
      await self.getCurrentAcademicYear();
      await self.LoadAcademicYears();
      await self.loadServices();
    },
    async validate() {
      return await this.$refs.formValidator.validate();
    },
    async search() {
      this.$ApiGet(`api/pei/getanalysisservice`, {
        AcademicYear: this.Filter.AcademicYear.id,
        StudentSieId: this.Filter.Sie,
        RegionId: this.Filter.Region,
        MunicipalityId: this.Filter.District,
        CenterId: this.Filter.Center,
        SchoolId: this.Filter.School,
        ServiceId: this.Filter.Service,
        WithMileage: false,
        PageIndex: this.pagi.currentPage,
      })
        .then((res) => {
          this.pagi.currentPage = res.data.currentPage;
          this.pagi.totalItemCount = res.data.totalItemCount;
          this.pagi.pageCount = res.data.pageCount;

          this.items = res.data.data.map((d) => {
            return {
              id: d.peiAnalysisServiceId,
              region: d.regionName,
              distrit: d.districtName,
              school: d.schoolName,
              name: d.studentName,
              PEI: d.peiId,
              SIE: d.studentSieId,
              terapy: d.therapyDescription,
              companion: null,
              mileage: null,
              commentary: null,
              editMode: false,
            };
          });
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    pageChanged(params) {
      this.pagi.currentPage = params.currentPage;
      this.search();
    },
    perPageChange(params) {
      this.pagi.count = params.currentPerPage;
      this.search();
    },
    async getNonMileageServices() {
      let isValid = await this.validate();
      if (!isValid) {
        this.ShowToast('Error', this.errorMessage, 'error');
        return;
      } else {
        this.search();
      }
    },
    async updateMileage(item) {
      this.$ApiPost('api/pei/analysisservice/updatenomileage', {
        PeiAnalysisServiceId: item.id,
        AcademicYearId: this.Filter.AcademicYear.id,
        StudentSieId: item.SIE,
        Mileage: parseInt(item.mileage),
        Companion: item.companion,
        Commentary: item.commentary,
      })
        .then(() => {
          this.ShowToast(
            'Proceso exitoso',
            'Los datos fueron guardados exitosamente.',
            'success'
          );
          this.search();
        })
        .catch((err) => this.ShowToast('Error', err.message, 'error'));
    },
  },

  async created() {
    await this.loadResources();
  },
  mounted() {
    this.LoadAlls();
  },
};
</script>

<style scoped>
.filter-container {
  background-color: #f4f6f3;
  padding: 15px;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator::before {
  margin-right: 0.5em;
}
.separator::after {
  margin-left: 0.5em;
}
.custom-ddf :placeholder-shown,
.custom-ddf .vs__search::placeholder {
  color: #495057;
  opacity: 0.8;
  line-height: 1.6;
}
</style>
